import { useEffect, useRef, useState } from 'react'
import { TOAST_EVENT } from '../../lib/toast'
import { Glyph } from './Icon'

/** One toast at a time, announced to screen readers, gone after two seconds. */
export function Toaster() {
  const [msg, setMsg] = useState<{ text: string; key: number } | null>(null)
  const timer = useRef(0)
  useEffect(() => {
    const on = (e: Event) => {
      const text = (e as CustomEvent<string>).detail
      if (typeof text !== 'string' || !text) return
      setMsg({ text, key: Date.now() })
      window.clearTimeout(timer.current)
      timer.current = window.setTimeout(() => setMsg(null), 2200)
    }
    window.addEventListener(TOAST_EVENT, on)
    return () => {
      window.removeEventListener(TOAST_EVENT, on)
      window.clearTimeout(timer.current)
    }
  }, [])
  return (
    <div className="toaster" role="status" aria-live="polite">
      {msg && <div key={msg.key} className="toast glass"><span className="toast-ic"><Glyph name="check" width={2.4} /></span>{msg.text}</div>}
    </div>
  )
}
